import { getAppConfigValue } from '@elliemae/pui-app-sdk';

export const isEligibilityExceptionsEnabled = (): boolean =>
  getAppConfigValue<boolean>('partner-ui.eligibilityExceptions') === true;
